import {
  useSavedViewConfiguration,
  useSavedViewConfigurationActions,
  useSavedViewConfigurationDirtyState,
} from '../../contexts/views/SavedViewConfigurationProvider'
import {SavedViewOptionsMenu} from './SavedViewOptionsMenu'
import {useSavedViewFields} from './use-saved-view-fields'

interface ConnectedSavedViewOptionsMenuProps {
  basePath: string
  disabled?: boolean
}

/**
 * The view options menu, connected to the saved view configuration and its fields. Each pick
 * applies as it is made.
 */
export function ConnectedSavedViewOptionsMenu({basePath, disabled = false}: ConnectedSavedViewOptionsMenuProps) {
  const {data: fields, isError, isPending} = useSavedViewFields(basePath)
  const configuration = useSavedViewConfiguration()
  const {applyConfiguration, prefetchConfiguration, reset} = useSavedViewConfigurationActions()
  const {dirty, isConfigurationDirty} = useSavedViewConfigurationDirtyState()

  return (
    <SavedViewOptionsMenu
      fields={fields}
      isPending={isPending}
      isError={isError}
      configuration={configuration}
      disabled={disabled}
      showDirtyIndicator={isConfigurationDirty}
      configurationDirty={dirty}
      onDiscard={reset}
      onApply={applyConfiguration}
      onIntent={prefetchConfiguration}
    />
  )
}
